var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"website-container"},[_c('Header-list',{ref:"header"}),_c('div',[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1)],1),_c('Footer-list',{ref:"footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }